export function resolvePath(path: string) {
  const metaRootContentPath = document.querySelector('meta[name=rootContentPath]')
  const rootContentPath = metaRootContentPath?.getAttribute('content')

  const originalPath = path

  if (rootContentPath) {
    path = path.replace(rootContentPath, '')
  }

  if (
    originalPath.indexOf('/content/') > -1 &&
    originalPath.indexOf('/content/dam') === -1 &&
    path.length > 0 &&
    !path.endsWith('.html')
  ) {
    return path + '.html'
  }

  return path
}
